export enum EmploymentStatusTypeId {
  Active = 1,
  Inactive = 2,
  Leave = 3
}
